// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dim-40[data-v-1b0dcd38] {\r\n  width: 40px;\r\n  height: 40px;\n}\n.fs-40[data-v-1b0dcd38] {\r\n  font-size: 40px;\n}\n.fs-22[data-v-1b0dcd38] {\r\n  font-size: 22px;\n}\n.lh-1[data-v-1b0dcd38] {\r\n  line-height: 1 !important;\n}\n.data-name[data-v-1b0dcd38] {\r\n  line-height: 1.3 !important;\n}\n.text-warning[data-v-1b0dcd38] {\r\n  color: #f3af54 !important;\n}\n.bg-warning[data-v-1b0dcd38] {\r\n  background-color: #f3af54 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
